<template>
  <div class='EnbProduto'
  :style="{
    backgroundColor: Prefes.produto.corBackground,
    color: Prefes.produto.corFont,
    fontFamily: Prefes.produto.font,
    fontStyle: parseInt(Prefes.produto.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.produto.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.produto.textDecoration) ? 'underline' : '',
    fontSize: Prefes.produto.fontHeight + 'px'
  }"
  >
    <enb-prod-img :data="data"/>
    <div class="name">
      {{ data.name }}
    </div>
    <prod-price :data="data"/>
    <btn-imgs :data="data"/>
    <btn-whats @click="sendMessageWhats(data)"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbProdImg from './EnbProdImg'
import BtnImgs from './BtnImgs'
import ProdPrice from './ProdPrice'
import BtnWhats from './BtnWhats'
export default {
  name: 'EnbProduto',
  components: { EnbProdImg, BtnImgs, ProdPrice, BtnWhats },
  props: ['data'],
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['sendMessageWhats'])
  }
}
</script>

<style scoped>
.EnbProduto {
  width: 260px;
  height: 410px;
  margin: 1%;
  border: thin solid #CCCCCC;
  border-radius: 8px;
  overflow: hidden;
}

.name {
  height: 40px;
  padding: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
